export default "__VITE_ASSET__Z01smVLC__"